import axios from 'axios';

export default {

    //Permet de récuperer la liste des challenges d'un utilisateur
    get(userId, length = 2, startIndex = 0) {
        let params = '?length=' + length;
        if(startIndex != null){
            params = params + '&start_index=' + startIndex;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/data' + params);
    },

    //Permet d'ajouter un nouveau challenge
    post(userId, challengeData) {
        return axios.post(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/add', challengeData);
    },

    //Permet de modifier un challenge existant
    patch(userId, challengeId, challengeData) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/edit/' + challengeId, challengeData);
    },

    //Permet de supprimer un challenge
    delete(userId, challengeId) {
        return axios.delete(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/delete/' + challengeId);
    },

    //Permet de récupérer la liste des catégorie pour le select lors d ela création d'un challenge
    getCategoriesList(reference){
        let params = '?reference=' + reference;
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/categories/list' + params);
    },

    //Permet de récupérer la liste des catégorie pour le select lors d ela création d'un challenge
    getCriterionList(categoryId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/criterion/' + categoryId +'/list');
    }
}
